import { Platform } from 'react-native';
import * as amplitudeWeb from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import {
	init,
	setUserId,
	track,
	getDeviceId
} from '@amplitude/analytics-react-native';


export function getAmplitudeDeviceID() {
  if(Platform.OS === 'web') {
    // return amplitude.getInstance().options.deviceId
    return amplitudeWeb.getDeviceId();
  } else {
    return getDeviceId();
  }
}


export const initAmplitude = ({userId = '' , token =''} : { userId : string , token? : string}): void => {
  if(Platform.OS === 'web') {
    userId === ''
    ? amplitudeWeb.init(token, undefined, { 
      defaultTracking: {
        pageViews: true,        // Alternative way to disable page views
        sessions: true,
        formInteractions: false,
        fileDownloads: false,
      }})
    : amplitudeWeb.setUserId(userId);

    const sessionReplayTracking = sessionReplayPlugin({sampleRate: 0.6});
    amplitudeWeb.add(sessionReplayTracking);
  } else {
    userId === ''
      ? init(token)
      : setUserId(userId);
  }
};

export const trackEvent = (eventName: string , eventProperties?: Record<string, any>): void => {
  try {
    if (Platform.OS === 'web') {
        try {
            amplitudeWeb.track(eventName , eventProperties ?? {});
            console.log('Screen Viewed web', eventName)
        } catch (error) {
            console.error('Error tracking Amplitude web event:', eventName , eventProperties);
        }
    } else {
        track(eventName , eventProperties ?? {});
        console.log('Screen Viewed Mobile', eventName)
    }
} catch (error) {
    console.error('Error Logging event')
}
};